<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Forecast Scanning
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Would you like to scan with VS in the coming season?</dt>
          <dd>{{ model.wants_scanning_vs || '-' }}</dd>
        </dl>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('scanning_history') ? 'subsection-disabled' : ''">
          <u>Scanning History</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'scanning_history')">
            <span class="glyphicon" :class="isRemovedSubsection('scanning_history') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sh, index) in model.CHARTS.scanning_table" :key="index"
              :class="getRowClass(model.CHARTS.scanning_table, 'Date', index)">

              <td class="text-left">{{ sh["Date"] }}</td>
              <td class="text-left">{{ sh["Description"] }}</td>
              <td class="text-left">{{ sh["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [ mixin ],
  props: ['model'],
  data() {
    return {
      stepName: 'ForecastScanning',
    }
  },
};
</script>
